import React from 'react';
import PlayButton from '../PlayButton/PlayButton';
import type { UseRadioPlayerReturn } from '../../hooks/useRadioPlayer';

interface PlayerControlsProps {
  variant?: 'desktop' | 'mobile';
  radioPlayerData: UseRadioPlayerReturn;
}

const PlayerControls: React.FC<PlayerControlsProps> = React.memo(({
  variant = 'mobile',
  radioPlayerData,
}) => {
  const { isPlaying, isLoading, hasError, togglePlayback } = radioPlayerData;

  const containerClass = variant === 'desktop' ? 'player-panel' : 'main-block';
  const controlsClass = variant === 'desktop' ? 'player-panel-controls' : 'play-button-wrapper';

  return (
    <div className={containerClass}>
      <div className={controlsClass}>
        <PlayButton
          isPlaying={isPlaying}
          isLoading={isLoading}
          hasError={hasError}
          onToggle={togglePlayback}
        />
      </div>
    </div>
  );
});

PlayerControls.displayName = 'PlayerControls';

export default PlayerControls;
